import React, { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FileUp } from "lucide-react";
import { api, authHeaders, fmtError } from "@/lib/api";
import { uploadImage } from "./ui";

export function ResumeUploadButton({ content, reload }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const url = await uploadImage(f);
      await axios.put(api("/api/admin/content/contact"), { value: { ...(content.contact || {}), resume: url } }, { headers: authHeaders() });
      toast.success("Resume updated. It's live on your site now.");
      reload();
    } catch (err) {
      toast.error(fmtError(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  return (
    <>
      <button onClick={() => ref.current?.click()} disabled={busy} data-testid="admin-upload-resume" className="text-xs font-bold uppercase tracking-wider px-3 py-2 border border-black rounded-full bg-black text-white hover:opacity-80 transition-opacity flex items-center gap-1 disabled:opacity-60">
        <FileUp size={12} /> {busy ? "Uploading…" : "Upload resume"}
      </button>
      <input ref={ref} type="file" accept=".pdf,application/pdf" className="hidden" onChange={onFile} data-testid="admin-upload-resume-input" />
    </>
  );
}
